import axios from "../../axiosConfig/axios";

export default {
    UserLogin(data){
        return axios.post(`user/auth`,
        data,
        {
            headers: {
                'Content-Type': 'application/json',
            }
        })
    },
    resetPassword(data){
        console.log(data)
        return axios.patch('/users/auth/password/reset',{
            forgetPasswordKey:data?.hash,
            newPassword:data?.password
        },
        {
            headers:{
                'Content-Type': 'application/json',
            }
        }
        )
    }
};
